import { createSlice } from '@reduxjs/toolkit';
import * as Seters from './seters';
import { IRisk } from '../../../../models/Dictionaries';

export interface State {
	risksOc: IRisk[];
	risksNnw: IRisk[];
	risksNnwKlauzule: IRisk[];
	risksKop: IRisk[];
	loaded: boolean;
}

export const initialState: State = {
	risksOc: [],
	risksKop: [],
	risksNnw: [],
	risksNnwKlauzule: [],
	loaded: false,
};

export const slice = createSlice({
	name: 'data/dictionaries/risks',
	initialState,
	reducers: Seters,
});

export const risksDictReducer = slice.reducer;
const Actions = slice.actions;
export { Actions };
